<style lang="sass" scoped>
.modal-body {
  word-wrap: break-word;
  white-space: pre-wrap;
}

.information {
  text-decoration-line: underline;
  color: blue;
}
</style>

<template>
<layout :shop="shop" :info-count="infoCount">
  <h1>お知らせ一覧</h1>

  <pagination :page.sync="page" :page-count="pageCount"></pagination>

  <table class="table">
    <tbody>
    <tr v-for="i in informations">
      <td class="col-md-2">{{ i.publish_at | dateformat 'Y/M/D (ddd)' }}</td>
      <td>
        <span class="label" @click="showModal(i)" v-bind:class="labelClass(i)">{{ shopName(i) }}</span>
        <span class="information" @click="showModal(i)">{{ i.message.substr(0, inlineMessageLength) }}</span>
        <span
            v-if="i.message.length > inlineMessageLength"
            class="glyphicon glyphicon-option-horizontal"
            aria-hidden="true"
            @click="showModal(i)"
        >(省略あり)</span>
      </td>
    </tr>
    </tbody>
  </table>

  <pagination :page.sync="page" :page-count="pageCount"></pagination>

  <modal :is-shown.sync="isModalShown">
    <div slot="content">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">{{{ linkifyHtml(shownInfo ? shownInfo.message : '') }}}</div>
      </div>
    </div>
  </modal>
</layout>
</template>


<script>
import moment from 'moment'
import linkifyHtml from 'linkifyjs/html'
import ShopType from 'ShopType'

export default {
  name: 'informations',
  route: {
    data({to: {params: {shopId}}}) {
      var data = {
        page: 1,
        pageCount: 1,
        isModalShown: false,
      }

      let requests = [
        this.apiGet(`/api/1.0/shops/${shopId}`, {page_size: -1}).then(response => {
          return {'shop': response.body.data}
        }),
        this.fetchInformations(shopId),
      ]

      return Promise.all(requests).then(results => {
        return results.reduce((r1, r2) => Object.assign(r1, r2), data)
      })
    },
  },
  props: {
    inlineMessageLength: {
      type: Number,
      default: 100,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      page: 1,
      pageCount: 1,
      isModalShown: false,
      shownInfo: null,
      shop: null,
      SHOP_TYPE_SHOP: ShopType.SHOP,
      SHOP_TYPE_GROUP: ShopType.GROUP,
      informations: [],
      infoCount: 0,
    }
  },
  methods: {
    fetchInformations(shopId, page = 1) {
      let params = {
        page_size: this.pageSize,
        page: page,
      }

      return this.apiGet(
        '/api/1.0/informations/',
        params,
        {shopAs: shopId}
      ).then(response => {
        return {
          'infoCount': response.body.count,
          'pageCount': Math.ceil(response.body.count / response.body.pageSize),
          'informations': response.body.results,
        }
      })
    },
    shopName(info) {
      return info._embedded ? info._embedded.shop.name : '-'
    },
    shopType(info) {
      return info._embedded ? info._embedded.shop.shopType : 2
    },
    labelClass(info) {
      switch (this.shopType(info)) {
        case ShopType.SHOP:
          return ['label-info']
        case ShopType.GROUP:
          return ['label-success']
        default:
          return []
      }
    },
    shortContent(content) {
      return content.sub
    },
    showModal(info) {
      this.isModalShown = true
      this.shownInfo = info
    },
    linkifyHtml(content) {
      return linkifyHtml(content)
    }
  },
  watch: {
    page(val) {
      this.fetchInformations(this.shop.pk, val).then(result => {
        this.pageCount = result.pageCount
        this.informations = result.informations
      })
    },
  },
  mixins: [
    require('mixin/login-required.vue'),
    require('mixin/api-client.vue'),
  ],
  components: {
    layout: require('layout.vue'),
    modal: require('ui/modal.vue'),
    pagination: require('ui/pagination.vue'),
  },
}
</script>



// WEBPACK FOOTER //
// index.vue?06d32b15